import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SponsorListPage = () => {
  const [sponsors, setSponsors] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSponsors = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/sponsors`);
        const data = await res.json();
        setSponsors(data);
      } catch (err) {
        console.error("Error fetching sponsors:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchSponsors();
  }, []);

  if (loading) return <p className="text-center mt-10">Loading...</p>;

  return (
    <div className="max-w-5xl mx-auto mt-10 px-6">
      <h2 className="text-2xl font-bold mb-6 text-center">Sponsors</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {sponsors.map((sponsor) => (
          <div
            key={sponsor.id}
            className="bg-white shadow-md rounded-md p-4 flex items-center space-x-4"
          >
            {sponsor.logo ? (
              <img
                src={`${process.env.REACT_APP_API_BASE_URL}${sponsor.logo}`}
                alt={sponsor.name}
                className="w-12 h-12 rounded-full object-cover border"
              />
            ) : (
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-green-100 text-green-700 font-bold text-lg border">
                {sponsor.name?.charAt(0) || "S"}
              </div>
            )}
            <div>
              <p className="text-lg font-semibold text-gray-800">{sponsor.name}</p>
              <a href={`mailto:${sponsor.email}`} className="text-blue-600 text-sm hover:underline">
                {sponsor.email}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SponsorListPage;